// extracted by mini-css-extract-plugin
export var header = "_v2-1";
export var maskBottom = "_v2-6";
export var maskMiddle = "_v2-7";
export var maskTop = "_v2-5";
export var root = "_v2-0";
export var scrollDownButton = "_v2-3";
export var scrollDownButtonHidden = "_v2-4";
export var viewport = "_v2-2";